module.exports = __webpack_public_path__ + "img/yishi15.6757711b.jpg";